module.exports = __webpack_public_path__ + "img/015424af979845229cdcf29bebc00333.6bf669c7.jpg";